'use strict';

var React = require('react');

const useValidityState = ({ onValidityChange, getState, validate, }) => {
    const previousReason = React.useRef(null);
    React.useEffect(() => {
        const validityState = getState();
        if (!validityState)
            return;
        const validityStateKeys = Object.keys(validityState);
        const reason = validityStateKeys.find(key => validityState[key]) ?? null;
        const isValid = reason === null;
        const validityHasChanged = reason !== previousReason.current;
        /*
         * should trigger onValidityChange only if reason has been changed or custom validation has been passed
         * and we need to know if the input is valid or not after the change on the UI
         */
        if (validityHasChanged || validate) {
            onValidityChange?.({ isValid, reason });
        }
        previousReason.current = reason;
    }, [getState, onValidityChange, validate]);
};
const useElementValidityState = (states, { value, required, elementRef, onValidityChange, validate }) => {
    React.useLayoutEffect(() => {
        if (!elementRef.current)
            return;
        const customError = validate?.(value);
        elementRef.current.setCustomValidity(customError || '');
        elementRef.current.reportValidity();
    }, [value, validate, elementRef, required]);
    const getState = React.useCallback(() => {
        const validityState = elementRef.current?.validity;
        if (!validityState)
            return;
        const entries = states.map(state => [state, validityState[state]]);
        return Object.fromEntries(entries);
        // value in dependcies array is kind of hack to update gesState reference
        // and so trigger the useEffect in useValidityState each time value change (it's what we want)
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [elementRef, states, value]);
    useValidityState({ onValidityChange, getState, validate });
};

exports.useElementValidityState = useElementValidityState;
exports.useValidityState = useValidityState;
//# sourceMappingURL=useValidityState.js.map
